'use strict';

import React, { Component } from 'react';

import './errorbox.less';


export default class ErrorBox extends Component {
  constructor(props){
    super(props);

    this.state = {
      message: ''
    };
    this.state.message = props.message || '';
  }

  render() {
    return (
      <div className={'alert alert-error '+ (this.state.message != ''?'':'hide')} ref='box'>
        {this.state.message}
        </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/Alert/ErrorBox.jsx